import { render, staticRenderFns } from "./OsSurveyWorkplaceSwitch.vue?vue&type=template&id=c0ce5e12&scoped=true"
import script from "./OsSurveyWorkplaceSwitch.vue?vue&type=script&lang=ts"
export * from "./OsSurveyWorkplaceSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ce5e12",
  null
  
)

export default component.exports